<ng-container *appLet="{
 currency: selectedCurrency$ | async,
} as $comp">
  <div class="destination-map-tooltip" (click)="$event.stopPropagation()" (clickOutside)="closeTooltip()">
    <div class="destination-map-tooltip__header">
      <h3 class="destination-map-tooltip__title">
        {{ tileContent?.name }} <span>({{ content?.stationCode }})</span>
      </h3>
      <div class="destination-map-tooltip__subtitle">
        {{ content?.whereWeFlyCopy?.['destinationDescription' + content?.stationCode] }}
      </div>
      <div class="destination-map-tooltip__close" (click)="closeTooltip()">
        <app-svg-icon icon="close-icon" [width]="20" [height]="20" fill="grays-text-light-gray"></app-svg-icon>
      </div>
    </div>
    <div class="destination-map-tooltip__image">
      <img [src]="image?.url"
           [alt]="image?.altText">
    </div>
    <hr class="destination-map-tooltip__separator">
    <div class="destination-map-tooltip__content">
      <div class="destination-map-tooltip__content-title">
        <app-svg-icon icon="plane-horizontal" [width]="16" [height]="15" fill="grays-text-light-gray"></app-svg-icon>
          {{ content?.whereWeFlyCopy?.flyTo }} {{ tileContent?.name }}
      </div>
      @if (destinations && destinations.length) {
        <div class="destination-map-tooltip__destinations"
             [class.destination-map-tooltip__destinations--full-width]="destinations.length % 2 !== 0">
          @for (destination of destinations; track $index) {
            <div class="destination-map-tooltip__destinations-item"
                 *appLet="{
                 destinationCode: destination.originCode === content?.stationCode ? destination.destinationCode : destination.originCode
                 } as $flight"
                 [attr.data-qa]="'destination-map-cta' + destination + content?.stationCode"
            (click)="searchForFlights($flight.destinationCode, $comp.currency)">
                {{ content?.whereWeFlyCopy?.directFrom }}
              <span>{{ destination.originCode === content?.stationCode ? destination.destination : destination.origin }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-container>
